import { BitkitUISideNav, IconMcp, useUISideNav } from '@bitrise/bitkit-v2';
import { useDisclosure } from '@chakra-ui/react/hooks';
import { useEffect } from 'react';

import { McpConnectionStatus } from '@/models/User';

import ConnectMcpDialog from './ConnectMcpDialog';
import { trackMcpSetupStarted, trackMcpSignpostShown } from './mcpTracking';

const STATUS_TEXTS: Record<McpConnectionStatus, string> = {
  none: 'Not connected',
  connected: 'Connected',
  expired: 'Connection expired',
};

// The side nav's status dot only comes in these three; an expired connection needs acting on, so it
// reads as critical rather than the amber it had of its own.
const STATUS_DOTS: Record<McpConnectionStatus, 'critical' | 'neutral' | 'success'> = {
  none: 'neutral',
  connected: 'success',
  expired: 'critical',
};

type McpNavWidgetProps = {
  status: McpConnectionStatus;
};

const McpNavWidget = ({ status }: McpNavWidgetProps) => {
  const { open, onOpen, onClose } = useDisclosure();
  const { expanded } = useUISideNav();

  useEffect(() => {
    trackMcpSignpostShown({
      source: 'side_nav_mcp_widget',
      mcpConnectionStatus: status,
      isSideNavCollapsed: !expanded,
    });
  }, [status, expanded]);

  const handleOpen = () => {
    trackMcpSetupStarted({
      source: 'side_nav_mcp_widget',
      mcpConnectionStatus: status,
      isSideNavCollapsed: !expanded,
    });
    onOpen();
  };

  return (
    <>
      <BitkitUISideNav.Link
        icon={IconMcp}
        onClick={handleOpen}
        secondaryText={STATUS_TEXTS[status]}
        status={STATUS_DOTS[status]}
      >
        Bitrise MCP
      </BitkitUISideNav.Link>
      <ConnectMcpDialog open={open} onClose={onClose} source="side_nav_mcp_widget" status={status} />
    </>
  );
};

export default McpNavWidget;
